import { config, authHeader, handleResponse } from '../helpers'

export const studentService = {
    getStudentTeamMentor,
    submitProposal,
}

function getStudentTeamMentor() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }

    return fetch(`${config.baseUrl}/student/team-status`, requestOptions)
        .then(handleResponse)
        .then(data => {
          return data
        })
}

function submitProposal(data){
    const requestOptions = {
        method: 'POST',
        headers: {'Content-Type':'application/json',...authHeader()},
        body:JSON.stringify(data.parameters)
    }

    return fetch(`${config.baseUrl}/student/submit-proposal-form`, requestOptions)
        .then(handleResponse)
        .then(data => {
          return data
        })
}
